import InfoToolTip from 'components/InfoToolTip';
import { Option } from 'types/select';
import { translate } from 'utils';

export const REFINEMENT_REASONS_OPTIONS: Option[] = [
  {
    value: 'Phased treatment requires refinement.',
    label: 'refinement.phased_treatment_requires_refinement'
  },
  {
    value: 'Teeth movement deviates from treatment plan.',
    label: 'refinement.teeth_movement_deviates_from_treatment_plan'
  },
  {
    value: 'The patient has a new restoration or filling.',
    label: 'refinement.the_patient_has_a_new_restoration_or_filling'
  },
  {
    value: 'Poor patient compliance',
    label: 'refinement.poor_patient_compliance'
  },
  {
    value:
      'Treatment plan changed (Please describe in detail in the Special Notes section below)',
    label: 'refinement.treatment_plan_changed'
  },
  {
    value: 'Others',
    label: 'common.others'
  }
];

export const ALIGNER_FITTING_OPTIONS = [
  {
    value: 'Fit',
    label: 'refinement.fit',
    labelComponent: (
      <div className='flex flex-row space-x-2'>
        <p>{translate('refinement.fit')}</p>
        <InfoToolTip
          message={'refinement.aligner_fitting_criteria'}
          className='w-5 h-5 text-PRIMARY'
          toolTipStyle='w-100'
        />
      </div>
    )
  },
  {
    value: 'Doesn’t fit',
    label: 'refinement.doesnt_fit',
    labelComponent: (
      <div className='flex flex-row space-x-2'>
        <p>{translate('refinement.doesnt_fit')}</p>
        <InfoToolTip
          message={'refinement.re_upload_full_arches_stl_required'}
          className='w-5 h-5 text-PRIMARY'
          toolTipStyle='w-fit'
        />
      </div>
    )
  }
];

export const DENTITION_SPACE_OPTIONS = [
  {
    value: 'Show resulting spacing after alignment',
    label: 'spacing.show_resulting_spacing_after_alignment'
  },
  {
    value: 'Have preference or specific instructions',
    label: 'spacing.have_preference_or_specific_instructions'
  }
];
